import React from 'react'
import {NavLink} from 'react-router-dom'

const typeColors = {
  consumable: 'mdl-color--cyan',
  equipment: 'mdl-color--brown',
  mod: 'mdl-color--deep-purple',
  structure: 'mdl-color--red',
  weapon: 'mdl-color--orange',
  other: 'mdl-color--indigo'
}

class ItemSummary extends React.Component {
  componentDidMount() {
    console.debug('componentDidMount', this.props)
  }

  render() {
    const {id, name, hasBlueprint, type, price, priceBlueprint, color} = this.props

    return (
      <div className="post mdl-cell mdl-cell--12-col mdl-cell--6-col-tablet mdl-cell--4-col-desktop mdl-grid mdl-grid--no-spacing">
        <div className="mdl-card mdl-shadow--2dp">
          <div className={`mdl-card__title ${typeColors[type]}-400 mdl-color-text--white`}>
            <h4 className="mdl-card__title-text">{name}</h4>

            {/* <span className="star">
              <div className="not-starred material-icons" style={{display: 'inline-block'}}>star_border</div>
              <div className="starred material-icons">star</div>
              <div className="star-count">0</div>
            </span> */}
          </div>
          <div className="mdl-card__content">
            <div
              className={`picture ${typeColors[type]}-900`}
              style={{backgroundImage: ''}}
            />
            <div className='tiers items'>
              <div className={`kind ${typeColors[type]}-100`}>Items</div>
              { price.map((prices, key) => <Value key={key} {...prices} level={key} id={id}/>) }
            </div>
            { hasBlueprint && <div className='tiers blueprints'>
                <div className={`kind ${typeColors[type]}-100`}>Blueprints</div>
                { priceBlueprint.map((prices, key) => <Value key={key} {...prices} level={key} id={id} kind='/blueprint'/>) }
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default ItemSummary


const Value = ({id, level, sell, buy, kind = ''}) => (
  <NavLink to={id.toLowerCase() + '/' + level + kind} className="text value">
    {level}
    <span title="lowest sell offer, buy price" className="sell">{sell > 0 && sell}</span>
    <span title="highest buy offer, sell price" className="buy">{buy > 0 && buy}</span>
  </NavLink>
)


// const OldPost = () => (
//   <div className="post post--KvwRr5wMp4e4nMQsgc0 mdl-cell mdl-cell--12-col mdl-cell--6-col-tablet mdl-cell--4-col-desktop mdl-grid mdl-grid--no-spacing">
//     <div className="mdl-card mdl-shadow--2dp">
//       <div className="mdl-card__title mdl-color--light-blue-600 mdl-color-text--white">
//         <h4 className="mdl-card__title-text">Old Post</h4>
//       </div>
//       <div className="header">
//         <div>
//           <div className="avatar" style={{backgroundImage: 'url(&quot;https://lh5.googleusercontent.com/-f5gcOQAM_WE/AAAAAAAAAAI/AAAAAAAAACw/0zJakOrz4ns/photo.jpg&quot;);'}}>
//           </div>
//           <div className="username mdl-color-text--black">Vítězslav Ackermann Ferko</div>
//         </div>
//       </div>
//       <span className="star">
//         <div className="not-starred material-icons" style={{display: 'inline-block'}}>star_border</div>
//         <div className="starred material-icons">star</div>
//         <div className="star-count">0</div>
//       </span>
//       <div className="text">1</div>
//       <div className="comments-container">
//       </div>
//       <form className="add-comment" action="#">
//         <div className="mdl-textfield mdl-js-textfield is-upgraded" data-upgraded=",MaterialTextfield">
//           <input className="mdl-textfield__input new-comment" type="text"/>
//           <label className="mdl-textfield__label">Comment...</label>
//         </div>
//       </form>
//     </div>
//   </div>
// )



// WEBPACK FOOTER //
// ./src/client/components/ItemSummary.jsx